module.exports = __webpack_public_path__ + "img/point-of-sale.bf1339f7.svg";